import { render, staticRenderFns } from "./VehicleTypeRegistrationData.vue?vue&type=template&id=5ac8842e&"
import script from "./VehicleTypeRegistrationData.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeRegistrationData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports